import { Component, Inject } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { AdmTable } from "../../api/models/adm-table";
import { AdmSource } from "../../api/models/adm-source";
import { DialogResult, DialogResultType } from "../DialogResult";
import { SIZE_HINTS } from "../../modules/admin/controls/admin-adm-definition/admin-adm-definition.component";

export interface AdmTableDialogData {
  table: AdmTable;
  sources: AdmSource[];
}

// Admin ADM Definition > Tables & Columns > a table's own Source/name/size/description. Returns ResultType.Ok to
// save, or Delete to toggle Retire/Restore (mirrors the row-level retire pattern the other ADM dialogs use).
@Component({
  selector: "adm-table-dialog",
  templateUrl: "./adm-table-dialog.component.html",
})
export class AdmTableDialogComponent {
  public result: AdmTable;
  public Result: DialogResult = { ResultType: DialogResultType.Cancel, ResultData: null };
  public sizeHints = SIZE_HINTS;

  constructor(public dialogRef: MatDialogRef<AdmTableDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: AdmTableDialogData) {
    this.result = { ...data.table };
  }

  get isNew(): boolean {
    return !this.data.table.admTableId;
  }

  onSave(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.result;
    this.dialogRef.close(this.Result);
  }

  onToggleRetired(): void {
    this.Result.ResultType = DialogResultType.Delete;
    this.Result.ResultData = this.result;
    this.dialogRef.close(this.Result);
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  static showDialog(dialog: MatDialog, data: AdmTableDialogData): Observable<DialogResult> {
    return dialog.open(AdmTableDialogComponent, { disableClose: false, width: "700px", data }).afterClosed();
  }
}
